const preventDefault = (evt) => {
  evt.preventDefault();
};

export { preventDefault };
//# sourceMappingURL=preventDefault.js.map
